/** @jsx h */
import { h } from 'preact'
import clsx from 'clsx'
import { useGlobal } from '../use-global'

const Input = ({
  type = 'checkbox',
  hasError,
  checked,
  onChange,
  name,
  required,
  value,
  className,
  id,
  label,
  description,
  disabled
}) => {
  const [{ canvasConfig }] = useGlobal()
  return (
    <div className='rcc_c_input-checkbox-radio-component' inert={disabled} data-cs-mask>
      <input
        className='rcc-sr-only'
        type={type}
        name={name}
        onChange={onChange}
        required={required}
        value={value}
        checked={checked}
        id={id}
      />
      <label
        className={clsx('rcc_c_custom-input rcc-block rcc-cursor-pointer rcc-relative rcc-leading-6', {
          'rcc-pl-6': canvasConfig.direction === 'ltr',
          'rcc_rtl rcc-pr-6 rcc-text-right': canvasConfig.direction === 'rtl'
        })}
        htmlFor={id}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      {description && (
        <p
          className={clsx('rcc-text-gray', {
            'rcc-pl-6': canvasConfig.direction === 'ltr',
            'rcc_rtl rcc-pr-6 rcc-text-right': canvasConfig.direction === 'rtl'
          })}
        >
          {description}
        </p>
      )}
    </div>
  )
}

export default Input
